import { createFileRoute } from '@tanstack/react-router';

import {
  OverviewReportPage,
  overviewReportQueryOptions,
  resolveRange,
  todayIn,
} from '@/features/reports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/reports/')({
  staticData: { tours: ['reports.overview'] },
  loaderDeps: ({ search }) => ({ range: search.range, from: search.from, to: search.to }),
  loader: ({ context, params, deps }) =>
    context.queryClient
      .query({
        ...overviewReportQueryOptions(
          params.storeId,
          resolveRange(deps, todayIn(context.store.timezone)),
        ),
        staleTime: 'static',
      })
      .catch(() => undefined),
  component: OverviewReportPage,
});
